<div data-ghost="product-card">
  <div class="aspect-w-1 aspect-h-1 w-full shimmer"></div>
  <div class="flex flex-col justify-between py-1 px-1 min-h-[120px] md:min-h-[145px]">
    <div>
      <div class="w-4/5 h-2 mb-1 shimmer"></div>
      <div class="flex w-[65%] justify-between">
        <div class="w-3/4 h-2 mb-1 shimmer"></div>
        <div class="h-2 shimmer"></div>
      </div>
    </div>
  </div>
</div>